module.exports = __webpack_public_path__ + "img/gb824.prt.fd6d31f6.jpg";